// @ts-nocheck
import _ from "lodash";
import Sheet from "atoms/sheet/sheet";
import * as dynamicGridSagaActions from "models/dynamicGrid/sagaActions";
import * as dynamicGridSelectors from "models/dynamicGrid/selector";
import * as tableColumnSagaActions from "models/tableColumns/sagaActions";
import * as tableColumnSelectors from "models/tableColumns/selector";
import SideCar from "molecules/sidecar/sidecar";
import Stack from "molecules/stack/stack";
import StackItem from "molecules/stackItem/stackItem";
import CustomizeViewModal from "organisms/CustomizeViewModal";
import ThetaMenu from "organisms/thetaMenu/thetaMenu";
import UploadData from "organisms/uploadData";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ThetaGridPaginated from "templates/thetaGridPaginated";
import * as constants from "./constants";
import Breadcrumbs from "atoms/breadcrumbs/breadcrumbs";
import ThetaDeleteModal from "organisms/deleteModal/deleteModal";
import { REQUESTS } from "utils/services/thetaretail/requests";
import GridActionBar from "atoms/GridActionBar";
import GridCsvUpload from "organisms/uploadData/gridCsvUpload";
import {
  isAclUsersReadWriteEnabled,
  isNewUploadEnabled,
} from "models/user/selector";
import Button from "atoms/button/button";
import {
  triggerCreateRole,
  triggerToggleRoleState,
  triggeRemovebulkAccess,
} from "./sagaActions";
import ReactModal from "atoms/modal/reactModal";
import ModalHeader from "atoms/modal/modalHeader";
import ModalBody from "atoms/modal/modalBody";
import ModalActions from "atoms/modal/modalActions";
import { getAutoCompleteData } from "models/autoComplete/selectors";
import { triggerFetchAutoComplete } from "models/autoComplete/sagaActions";
import { triggerFetchAvailableWorkflows } from "models/appSelector/sagaActions";
import { getAvailableWorkflows } from "models/appSelector/selectors";
import { handleAddOperation, handleRemoveOperation } from "./sagas";
import { fetchBookmarksList } from "models/bookmarks/sagaActions";
import DeleteModal from "components/DeleteModal";
import Label from "atoms/label/label";
import TextInput from "atoms/TextInput/textInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import { Button as AntButton, Tooltip } from "antd";


const Roles: React.FunctionComponent = (props) => {
  const tableId = constants.TABLE_ID.toString();
  const [openFilter, setOpenFilter] = React.useState<boolean>();
  const [isUploadEnabled, toggleUpload] = React.useState<boolean>(false);
  const [showModal, setShowModal] = React.useState(false);
  const [rowData, setRowData] = React.useState(null);
  const [isDeleteModal, toggleDeleteModal] = React.useState(false);
  const gridMeta = useSelector((state) =>
    dynamicGridSelectors.getGridMetadata(state, constants.TABLE_ID)
  );
  const [isCreateEnabled, toggleCreate] = React.useState(false);
  const [roleName, setRoleName] = React.useState("");
  const rolesList = useSelector((state) =>
    getAutoCompleteData(state, "acl-roles")
  );
  const [role, setRole] = React.useState(null);
  const dispatch = useDispatch();
  const hasWriteAccess = useSelector(isAclUsersReadWriteEnabled);
  const hasDeleteAccess = true;
  const hasSearchFilters = useSelector((state) =>
    dynamicGridSelectors.hasSearchFilters(state, constants.TABLE_ID)
  );
  const workflows = useSelector(getAvailableWorkflows);
  const allOperations = workflows.reduce(
    (acc, w) => _.uniqBy([...acc, ...w.Operations], "OperationValue"),
    []
  );
  const userOperations = useSelector((state) =>
    getAutoCompleteData(state, "acl-user-operations")
  );
  const isCustomizeViewModalEnabled = useSelector((state) =>
    tableColumnSelectors.isCustomizeViewModalEnabled(state)
  );
  const allAvaliableRows = useSelector((state) =>
    dynamicGridSelectors.getGridData(state, constants.TABLE_ID)
  );

  const selectedItems = useSelector((state) =>
    dynamicGridSelectors.getTableSelection(state, constants.TABLE_ID)
  );

  const selectedRows = allAvaliableRows?.filter((item) =>
    selectedItems?.selectedRowKeys?.find((o) => item.id === o)
  );

  useEffect(() => {}, [allOperations, userOperations]);

  React.useEffect(() => {
    if (openFilter === undefined) {
      setOpenFilter(hasSearchFilters);
    }
  }, [hasSearchFilters]);

  const fetchRolesList = (search) => {
    dispatch(
      triggerFetchAutoComplete({
        componentId: "acl-roles",
        options: {
          service: "acl",
          url: "roles/list",
          displayKey: "RoleName",
          selectionKey: "RoleID",
          body: {
            IsActive: true,
            search,
          },
        },
      })
    );
  };
  useEffect(() => {
    fetchRolesList();
    dispatch(triggerFetchAvailableWorkflows());
  }, []);

  React.useEffect(() => {
    dispatch(
      dynamicGridSagaActions.erpEnabled({ tableId: constants.TABLE_ID })
    );
    dispatch(fetchBookmarksList({ tableId: constants.TABLE_ID }));
  }, [dispatch]);

  useEffect(() => {
    if (
      rolesList?.length &&
      !rolesList.find((r) => r.RoleID === role?.roleId)
    ) {
      setRole({
        roleName: rolesList[0]?.RoleName,
        roleId: rolesList[0]?.RoleID,
      });
    }
  }, [rolesList, role]);

  const handleRefreshClick = React.useCallback(() => {
    dispatch(
      dynamicGridSagaActions.refreshGridData({
        tableId: constants.TABLE_ID,
      })
    );
  }, [tableId, dispatch]);

  const handleResetTableColumns = React.useCallback(async () => {
    dispatch(tableColumnSagaActions.resetTableColumnsAg(constants.TABLE_ID));
  }, [dispatch, tableId]);

  const customizeViewHandler = React.useCallback(
    (isCustomizeViewModalEnabled: boolean) => {
      dispatch(
        tableColumnSagaActions.setCustomizeViewModal(
          isCustomizeViewModalEnabled
        )
      );
    },
    []
  );

  const handleMenuItemClick = React.useCallback(
    (option: string) => {
      switch (option) {
        case constants.MENU_ITEMS_VALUES.CUSTOMIZE_VIEW:
          return customizeViewHandler(true);
        case constants.MENU_ITEMS_VALUES.RESET_VIEW:
          return handleResetTableColumns();
        case constants.MENU_ITEMS_VALUES.UPLOAD_DATA:
          return toggleUpload(true);
        case constants.MENU_ITEMS_VALUES.DELETE:
          return deleteItems();
        default:
          return;
      }
    },
    [handleResetTableColumns]
  );

  const getDisabledStatus = React.useCallback(
    (option: any) => {
      switch (option.value) {
        case constants.MENU_ITEMS_VALUES.CUSTOMIZE_VIEW:
        case constants.MENU_ITEMS_VALUES.RESET_VIEW:
        case constants.MENU_ITEMS_VALUES.UPLOAD_DATA:
          return false;
        case constants.MENU_ITEMS_VALUES.DELETE:
          return !selectedItems?.selectedRowKeys?.length;
        default:
          return true;
      }
    },
    [selectedItems]
  );

  const hideCustomizeViewModal = React.useCallback(() => {
    customizeViewHandler(false);
  }, []);

  const uploadCloseClickHandler = React.useCallback(() => {
    toggleUpload(false);
  }, []);

  const handleBulkDeleteClick = () => {
    dispatch(
      triggeRemovebulkAccess({
        tableId: constants.TABLE_ID,
        ids: selectedItems.selectedRowKeys,
      })
    );
    toggleDeleteModal(false);
    setTimeout(() => {
      dispatch(
        dynamicGridSagaActions.refreshGridData({
          tableId: constants.TABLE_ID,
          isSoftRefresh: true,
        })
      );
    }, 2000);
  };

  const deleteItems = () => {
    toggleDeleteModal(true);
  };

  const onCreateRole = () => {
    setRoleName("");
    dispatch(
      triggerCreateRole({
        roleName,
        componentId: "acl-roles",
      })
    );
    setTimeout(() => {
      dispatch(
        dynamicGridSagaActions.refreshGridData({
          tableId: constants.TABLE_ID,
        })
      );
    }, 2000);
    toggleCreate(false);
  };

  const onClose = () => {
    toggleCreate(false);
  };

  const onDeactivateRole = (row) => {
    try {
      dispatch(
        triggerToggleRoleState({ roleId: row.RoleID, componentId: "acl-roles" })
      );
      setTimeout(() => {
        dispatch(
          dynamicGridSagaActions.refreshGridData({
            tableId: constants.TABLE_ID,
          })
        );
      }, 2000);
    } catch (e) {
      console.log(e);
    }
  };

  const isNewUpload = useSelector(isNewUploadEnabled);

  const gridConfig = {
    enableSelection: true,
    enableSorting: true,
    enableMultiSort: true,
    // gridActions: (hasWriteAccess || hasDeleteAccess),
    customActions: (hasWriteAccess || hasDeleteAccess) && {
      width: 90,
      enabled: true,
      component: ({ row }) => {
        return (
          <Stack gutter="small" align="center" position="center">
            <StackItem>
              {/* <Icon
                isActive
                type="secondary"
                size="small"
                disabled={row?.IsReadOnly}
                onClick={() => onDeactivateRole(row)}
                faAlias={"faTrash"}
              ></Icon> */}
              <Stack className="tbl-action-buttons">
                <Button
                  disabled={row?.IsReadOnly}
                  handleClick={() => (setShowModal(true), setRowData(row))}
                >
                  {" "}
                  <i className="icon-trash" />
                </Button>
              </Stack>
            </StackItem>
          </Stack>
        );
      },
    },
    selectionCallBack: () => {},
  };

  const _handleModulePermission = async (params) => {
    const { colDef, data, value } = params;
    const queryName = colDef?.metaData?.AppColumnQueryName;

    if (colDef?.metaData?.ColumnType === "checkbox") {
      const operationId = `${queryName.substring(2)}Id`;
      const payload = {
        roleId: data.RoleId,
        operations: [data[operationId]],
      };

      try {
        if (!value) {
          return await handleRemoveOperation({ payload });
        } else {
          return await handleAddOperation({ payload });
        }
      } catch (error) {
        return error;
      }
    }
  };

  // throttle the function to run once every 500ms (adjust delay as needed)
  const handleModulePermission = _.throttle(_handleModulePermission, 500, {
    leading: true,
    trailing: true,
  });

  const templateConfig = {
    gridConfig,
    isFilterEnabled: openFilter === undefined ? false : openFilter,
    tableId: constants.TABLE_ID,
    childGridDataProviderOptions: {
      ...REQUESTS.POST.GET_GRID_DETAILS_V2,
    },
    dataProviderOptions: {
      type: "POST",
      ...REQUESTS.POST.GET_MONGO_GRID_DETAILS_V2,
      pathParams: { tableId: constants.TABLE_ID },
      version: 2,
    },
    selectRowKey: "RoleID",
    childCellRendererParams: {
      sortModal: [{ colId: "WorkflowDisplayName", sort: "asc" }],
    },
    childCustomActions: handleModulePermission,
  };

  return (
    <>
      <Stack isVertical>
        <StackItem>
          <GridActionBar>
            <div className="content-head">
              <Stack gutter="medium" align="space-between">
                <div className="content-head-lt">
                  <Breadcrumbs crumbs={props.breadcrumbs} />
                </div>
                <div className="content-head-rt">
                  <Stack gutter="medium" className="action-btns">
                    {hasWriteAccess && (
                      <StackItem className="action-btn">
                        <Button
                          isPrimary
                          handleClick={() => toggleCreate(true)}
                        >
                          Create New Role
                        </Button>
                      </StackItem>
                    )}
                    {isNewUpload && gridMeta?.UploadTableID && (
                      <StackItem className="action-btn">
                        <GridCsvUpload
                          uploadTableId={gridMeta?.UploadTableID}
                          parentTableId={tableId}
                        />
                      </StackItem>
                    )}
                    <StackItem className="action-btn">
                      <Tooltip title="Refresh">
                        {" "}
                        <AntButton
                          className="menu-action--button"
                          icon={
                            <FontAwesomeIcon
                              className="font-icon"
                              isActive
                              icon={faArrowsRotate}
                            />
                          }
                          onClick={handleRefreshClick}
                        />
                      </Tooltip>
                    </StackItem>
                    <StackItem className="action-btn">
                      <Tooltip title="More Options">
                        {" "}
                        <ThetaMenu
                          type="3Dots"
                          options={
                            hasWriteAccess
                              ? constants.MENU_ITEMS
                              : [constants.MENU_ITEMS[0]]
                          }
                          handleItemClick={handleMenuItemClick}
                          isDisabled={getDisabledStatus}
                        />
                      </Tooltip>
                    </StackItem>
                  </Stack>
                </div>
              </Stack>
            </div>
          </GridActionBar>
        </StackItem>
        <StackItem isStretch isGrow>
          <Sheet isPage className="order-tbl">
            <Stack isVertical gutter="medium">
              <StackItem isGrow isStretch>
                <ThetaGridPaginated config={templateConfig} />
              </StackItem>
            </Stack>
          </Sheet>
        </StackItem>
      </Stack>

      {isCreateEnabled && (
        <ReactModal>
          <ModalHeader>Create Role</ModalHeader>
          <ModalBody>
            <Stack isVertical gutter="small">
              <StackItem>
                <Label>Role Name:</Label>
              </StackItem>
              <StackItem isStretch>
                <TextInput
                  value={roleName}
                  onChange={(e) => setRoleName(e.target.value)}
                />
              </StackItem>
            </Stack>
          </ModalBody>
          <ModalActions>
            <Stack align="right" gutter="small">
              <StackItem>
                <Button isText type="secondary" handleClick={onClose}>
                  {" "}
                  Cancel
                </Button>
              </StackItem>
              <StackItem>
                <Button
                  isPrimary
                  disabled={!roleName}
                  handleClick={onCreateRole}
                >
                  {" "}
                  Create Role
                </Button>
              </StackItem>
            </Stack>
          </ModalActions>
        </ReactModal>
      )}

      {isCustomizeViewModalEnabled && (
        <CustomizeViewModal
          hideModal={hideCustomizeViewModal}
          tableId={constants.TABLE_ID}
        />
      )}
      {isUploadEnabled && (
        <SideCar
          isActive={isUploadEnabled}
          handleOnClose={uploadCloseClickHandler}
        >
          <UploadData tableId={tableId} />
        </SideCar>
      )}
      {isDeleteModal && (
        <ThetaDeleteModal
          hideModal={() => {
            toggleDeleteModal(false);
          }}
          modalTitle={"roles"}
          title={` (${
            selectedItems?.isSelectAll
              ? "All"
              : selectedItems?.selectedRowKeys?.length
          }) selected  role${
            selectedItems?.selectedRowKeys?.length > 1 ? "s" : ""
          }`}
          handleDeleteClick={handleBulkDeleteClick}
          isLocked={true}
        />
      )}
      {showModal && (
        <DeleteModal
          title={"Role"}
          success={() => {
            onDeactivateRole(rowData);
          }}
          hideModal={() => setShowModal(false)}
        />
      )}
    </>
  );
};
export default Roles;
